import axios from 'axios';

const fut = axios.create({
	baseURL: 'https://api.football-data.org/v2',
	headers: { 'X-Auth-Token': `3264c1612891464e8843fc1c4f006451` },
});

export default fut;
